import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'feedback-ui', {
    feedbackEditorFooterYouCan: 'You can',
    feedbackEditorFooterCloseThisBox: 'close this box',
    feedbackEditorFooterWithoutSubmitting: 'without submitting it and come back to it later.',
    viewFeedback: 'View feedback',
    sendToTrash: 'Send to trash',
    ratingTerrible: 'Terrible',
    ratingOkay: 'Okay',
    ratingGood: 'Good',
    ratingAwesome: 'Awesome',
    tellUsMore: 'Tell us more',
    ratingCommentPlaceholder: 'What worked, what did not?',
    send: 'Send',
    rateThis: 'How was this?',
    discardFeedbackTitle: 'Discard Feedback?',
    discardFeedbackDescription: 'Are you sure you want to discard this feedback?',
    discard: 'Discard',
    feedbackDiscarded: 'Feedback discarded',
    pleaseEnterATitle: 'Please enter a title',
    feedbackSubmitted: 'Feedback submitted',
    feedbackMarkedAsRead: 'Feedback marked as read',
    feedbackMovedToTrash: 'Feedback moved to the trash',
    feedbackRestoreFailed: 'Could not restore the feedback',
  });
}
